export enum StepperSteps {
  CONSULTATION = "Consultation",
  PRODUCT_SELECTION = "Treatment options",
  PERSONAL_DETAILS = "Personal details",
  DELIVERY_DETAILS = "Delivery details",
  PAYMENT_DETAILS = "Payment details",
}
